import { DashboardReviewContext, Result } from 'constants/interfaces'
import keys from 'constants/keys'
import { DeepDiveInsights } from 'redux/actions/tasks_v2'
import { findResultForMutation } from 'components/TasksV2/model/resultRequests'

export interface MediaGalleryEntry {
  contextId: string
  subtaskId: string | null
  mediaIndex: number
  subtaskIds: string[]
  contexts: DashboardReviewContext[]
}

/** Keep preview, exports and the opened result on the same occurrence and latest result row. */
export function getMediaGalleryResults(results: Result[], recurrenceTs: string | null): Result[] {
  const groups = new Map<string, Result[]>()
  results.forEach((result) => {
    if (
      result.sub_task_type !== keys.SUBTASK_TYPES.IMAGE_SUBTASK &&
      result.sub_task_type !== keys.SUBTASK_TYPES.VIDEO_SUBTASKS
    )
      return

    const identity = JSON.stringify([result.context_id, result.st_id])
    const group = groups.get(identity) || []
    group.push(result)
    groups.set(identity, group)
  })

  return Array.from(groups.values()).flatMap((group) => {
    const result = findResultForMutation(group, group[0].st_id, group[0].context_id, recurrenceTs)
    return result ? [result] : []
  })
}

/** Use the authorized gallery scope, including contexts whose next page has not loaded yet. */
export function getMediaGalleryContexts(
  contextIds: string[],
  deepDive: DeepDiveInsights,
  getName: (contextId: string) => string
): DashboardReviewContext[] {
  return Array.from(new Set(contextIds))
    .filter((id) => !!deepDive.contexts[id])
    .map((contextId) => ({
      contextId,
      taskContextId: deepDive.contexts[contextId].taskContextId,
      name: getName(contextId),
      status: deepDive.contexts[contextId].status,
      statuses: (deepDive.insights[contextId]?.items || []).reduce<Record<string, number>>((statuses, item) => {
        statuses[item.st_id] = item.status
        return statuses
      }, {}),
    }))
}
